module.exports = __webpack_public_path__ + "static/Gastronomie-e43707588f52d3da01656ff666b0ac9a.png";